<form *ngIf="form" [formGroup]="form">
  <div fxLayout="column">
    <div formArrayName="items" *ngFor="let item of form?.controls.items.controls; let i = index">
      <mat-checkbox [formControlName]="i" [id]="getId(i)" class="checkboxPadding" [(ngModel)]="_list[i].checked" (change)="change(_list[i])">{{_list[i].name}}</mat-checkbox>
    </div>
  </div>
</form>
